import { render, staticRenderFns } from "./CartPayment.vue?vue&type=template&id=22ca27d4&"
import script from "./CartPayment.vue?vue&type=script&lang=js&"
export * from "./CartPayment.vue?vue&type=script&lang=js&"
import style0 from "./CartPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports